// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"118":"EmailNotificationSignupForm","133":"winners","224":"register","342":"nominate","487":"judges","639":"categories"}[chunkId] + "." + {"118":"53293859","133":"6eaa20fd","224":"4426b11d","342":"741ba023","487":"3aecd8a9","639":"a780b7e3"}[chunkId] + ".css";
};